import { ArticleList } from '../components/ArticleList'
import { CustomContactFields } from '../components/CustomContactFields'
import { InvalidRuleModal } from '../components/InvalidRuleModal'
import { PowerCalculation } from '../components/PowerCalculation'
import { useUpdateOrderDialogOpenState } from '../store/orderDialog/orderDialogHooks'
import { SunovationRoot } from '../three/scene/SunovationScene'
import { env, useSelectedValueByVariableKey, useVariableByKey } from '@k3/core'
import { K3AppExtensions } from '@k3/core/src/lib/types/K3Extensions'
import { useEffect, useState } from 'react'

type ConfigType = Record<string, string | Record<string, string>> & {
  body?: BodyInit
}
export const app: K3AppExtensions = {
  configurator: {
    root: (Wrapped) => (props) => {
      const [valid, setValid] = useState(false)

      const redirect = () =>
        window.location.assign(window.location.origin + '#/admin/login')

      useEffect(() => {
        try {
          const token = localStorage.getItem(env.apiUrl + '$token')
          if (token) {
            const headers = {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-language': 'lang',
              Authorization: 'Bearer ' + token,
            }

            const apiUrl = env.apiUrl + '/api/v1.0/me'

            const config: ConfigType = {
              method: 'GET',
              mode: 'cors',
              cache: 'no-cache',
              credentials: 'same-origin',
              headers,
              redirect: 'follow',
              referrerPolicy: 'no-referrer',
            }

            fetch(apiUrl, config)
              .then((resp) => {
                if (resp.ok) {
                  resp.json().then((json) => {
                    console.log(json)
                    setValid(true)
                  })
                }
              })
              .catch(() => {
                redirect()
              })
          } else {
            redirect()
          }
        } catch {
          redirect()
        }
      })

      return valid ? <Wrapped {...props} /> : <></>
    },
  },
  mobileLabelActionDisplay: {
    root: (Wrapped) => (props) => {
      const variable = useVariableByKey('frontGlassColor')
      const selectedValue = useSelectedValueByVariableKey('frontGlassColor')
      if (variable && selectedValue) {
        return (
          <Wrapped {...props}>
            <PowerCalculation />
          </Wrapped>
        )
      } else {
        return <></>
      }
    },
  },
  labelActionDisplay: {
    root: () => () => {
      const variable = useVariableByKey('frontGlassColor')
      const selectedValue = useSelectedValueByVariableKey('frontGlassColor')
      if (variable && selectedValue) {
        return <PowerCalculation />
      } else {
        return <></>
      }
    },
  },

  price: {
    root:
      (Wrapper) =>
      ({ sx, ...props }) => {
        const newSx = {
          ...sx,
          mr: 1,
          px: 2,
          py: 6 / 8,
          borderRadius: 1 / 2,
          boxShadow: 2,
          placeSelf: 'center',
        }
        return <Wrapper {...props} sx={newSx} />
      },
  },
  k3d: {
    root: () => () => {
      return <SunovationRoot />
    },
  },
  orderDialog: {
    root:
      (OriginalDialog) =>
      ({ handleClose, ...props }) => {
        const update = useUpdateOrderDialogOpenState()
        update(true)
        const newClose = () => {
          update(false)
          handleClose()
        }
        return <OriginalDialog handleClose={newClose} {...props} />
      },
    contact: {
      fields: {
        root: () => (props) => {
          return <CustomContactFields {...props} />
        },
      },
    },
    priceTable: {
      root: () => () => {
        return <ArticleList />
      },
    },
  },
  invalidRuleModal: {
    root: InvalidRuleModal,
  },
}
